/**
 * component tree:
 */

import { Grid, InputAdornment, TextField, useTheme, alpha, MenuItem, Button, CircularProgress } from "@mui/material"
import {
  Box,
  Call,
  Card,
  CardPos,
  DocumentDownload,
  DocumentText,
  GlobalSearch,
  House2,
  Instagram,
  LampCharge,
  Location,
  Message,
  MessageText1,
  Mobile,
  Note,
  Personalcard,
  ShopAdd,
  ShoppingCart,
  Sms,
  TickSquare,
  Timer1,
  UserSquare
} from "iconsax-react"
import { FC, useState } from "react"
import { useForm } from "react-hook-form"
import axios from "../../../../lib/axios"
import { toast } from "react-toastify"
import AppStickSection from "../../../../components/AppStickSection"
import { onlyDigitsWithMaxLen } from "../../../../components/common/inputs/helper"
import ValidationHelperText from "../../../..//components/common/validation-helper-text"
import { LinkedIn, Telegram, Facebook, Twitter } from "@mui/icons-material"
import mobileValidation from "../../../../components/common/inputs/mobileValidation"
import MerchantRules from "../../../../components/pages/merchant/components/merchantRules"

export interface LegalProps {
  setConfirm: any
}

const Legal: FC<LegalProps> = ({ setConfirm }) => {
  /**
   * External Hooks
   * ______________________________________________________________________________
   */
  const theme = useTheme()

  /**
   * Consts and Variables
   * _______________________________________________________________________________
   */

  const [state, setState] = useState<"loading" | "error" | "done">("done")

  const {
    control,
    handleSubmit,
    register,
    reset,
    formState: { errors }
  } = useForm()

  const handleMercharReq = value => {
    setState("loading")
    const data = {
      type: 1401,
      companyName: value?.companyName,
      brandName: value?.brandName,
      ceoFullName: value?.ceoFullName,
      ownerNationalCode: value?.ownerNationalCode,
      ceoPhoneNumber: value?.ceoPhoneNumber,
      businessLicenseNumber: value?.businessLicenseNumber,
      agentFullName: value?.agentFullName,
      agentPhoneNumber: value?.agentPhoneNumber,
      telephoneNumber: value?.telephoneNumber,
      email: value?.email,
      classOfActivity: value?.classOfActivity,
      branchCount: value?.branchCount ? value?.branchCount : null,
      sellType: +value?.sellType,
      businessHistory: value?.businessHistory,
      mellatAcountNumber: value?.mellatAcountNumber,
      mellatTerminalNumber1: value?.mellatTerminalNumber1,
      mellatTerminalNumber2: value?.mellatTerminalNumber2,
      mellatTerminalNumber3: value?.mellatTerminalNumber3,
      address: value?.address,
      postalCode: value?.postalCode,
      website1: value?.website1,
      website2: value?.website2,
      website3: value?.website3,
      instagram: value?.instagram,
      facebook: value?.facebook,
      twitter: value?.twitter,
      telegram: value?.telegram,
      linkedIn: value?.linkedIn,
      megaBank: value?.megaBank,
      description: value?.description,
      trackingCode: value?.trackingCode
    }

    axios
      .post("/api/v1/merchant/addMerchantRequest", data)
      .then(response => {
        if (response?.status === 200) {
          if (response?.data?.succeed) {
            setState("done")
            setConfirm(response?.data.value)
            reset()
          } else {
            setState("error")
            toast.error(response?.data?.message)
          }
        }
      })
      .catch(() => {
        setState("error")
      })
  }

  const DownloadContractFile = () => {
    const link = document.createElement("a")
    link.href = "/jetvamContract.pdf"
    link.download = "پیش نویس قرارداد جت وام .pdf"
    link.click()
  }
  const isValidEmail = email => {
    // eslint-disable-next-line no-useless-escape
    return /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
      email
    )
  }
  const handleEmailValidation = email => {
    if (email?.length) {
      const isValid = isValidEmail(email)
      return isValid
    } else {
      return true
    }
  }
  return (
    <Grid>
      <form onSubmit={handleSubmit(handleMercharReq)}>
        <Grid spacing={1} gap={2} container pb='20px'>
          <MerchantRules register={register} errors={errors} />
          <Grid width={"95%"} m='auto' gap={3}>
            <AppStickSection title={"اطلاعات کسب و کار"} />
            <Grid container spacing={2} item xs={12} display={"flex"}>
              <Grid item xs={12} md={3}>
                <TextField
                  label='نام شرکت'
                  fullWidth
                  size='small'
                  name='companyName '
                  inputProps={{ maxLength: 50 }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position='start'>
                        <House2 size={20} color={theme.palette.primary.dark} />
                      </InputAdornment>
                    )
                  }}
                  sx={{
                    caretColor: theme.palette.secondary.main,
                    "& .MuiInputBase-root": {
                      borderRadius: "8px",
                      backgroundColor: alpha(theme.palette.grey[200], 0.5)
                    }
                  }}
                  {...register("companyName", {
                    required: {
                      value: true,
                      message: "نام شرکت الزامی است"
                    }
                  })}
                />
                <ValidationHelperText
                  error={!!errors?.companyName}
                  helperText={errors?.companyName?.message as string}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  size='small'
                  label='نام برند'
                  fullWidth
                  name='brandName'
                  inputProps={{ maxLength: 50 }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position='start'>
                        <LampCharge size={20} color={theme.palette.primary.dark} />
                      </InputAdornment>
                    )
                  }}
                  sx={{
                    caretColor: theme.palette.secondary.main,
                    "& .MuiInputBase-root": {
                      borderRadius: "8px",
                      backgroundColor: alpha(theme.palette.grey[200], 0.5)
                    }
                  }}
                  {...register("brandName", {
                    required: {
                      value: true,
                      message: "نام برند الزامی است"
                    }
                  })}
                />
                <ValidationHelperText error={!!errors?.brandName} helperText={errors?.brandName?.message as string} />
              </Grid>

              <Grid item xs={12} md={3}>
                <TextField
                  label='شماره اقتصادی'
                  fullWidth
                  size='small'
                  name='businessLicenseNumber'
                  type='number'
                  onKeyDown={onlyDigitsWithMaxLen(15)}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position='start'>
                        <DocumentText size={20} color={theme.palette.primary.dark} />
                      </InputAdornment>
                    )
                  }}
                  sx={{
                    caretColor: theme.palette.secondary.main,
                    "& .MuiInputBase-root": {
                      borderRadius: "8px",
                      backgroundColor: alpha(theme.palette.grey[200], 0.5)
                    }
                  }}
                  {...register("businessLicenseNumber", {
                    required: {
                      value: true,
                      message: "شماره اقتصادی الزامی است"
                    }
                  })}
                />
                <ValidationHelperText
                  error={!!errors?.businessLicenseNumber}
                  helperText={errors?.businessLicenseNumber?.message as string}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  size='small'
                  inputProps={{ maxLength: 50 }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position='start'>
                        <ShoppingCart size={20} color={theme.palette.primary.dark} />
                      </InputAdornment>
                    )
                  }}
                  sx={{
                    caretColor: theme.palette.secondary.main,
                    "& .MuiInputBase-root": {
                      borderRadius: "8px",
                      backgroundColor: alpha(theme.palette.grey[200], 0.5)
                    }
                  }}
                  label='صنف فعالیت'
                  fullWidth
                  name='classOfActivity'
                  {...register("classOfActivity", {
                    required: {
                      value: true,
                      message: "صنف فعالیت الزامی است"
                    }
                  })}
                />
                <ValidationHelperText
                  error={!!errors?.classOfActivity}
                  helperText={errors?.classOfActivity?.message as string}
                />
              </Grid>

              <Grid item xs={12} md={3}>
                <TextField
                  size='small'
                  InputProps={{
                    type: "number",
                    endAdornment: (
                      <InputAdornment position='start'>
                        <ShopAdd size={20} color={theme.palette.primary.dark} />
                      </InputAdornment>
                    )
                  }}
                  sx={{
                    caretColor: theme.palette.secondary.main,
                    "& .MuiInputBase-root": {
                      borderRadius: "8px",
                      backgroundColor: alpha(theme.palette.grey[200], 0.5)
                    }
                  }}
                  label='تعداد شعب'
                  type='number'
                  fullWidth
                  name='branchCount'
                  defaultValue={null}
                  {...register("branchCount")}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  autoComplete='off'
                  size='small'
                  defaultValue=''
                  label='نوع فروش'
                  fullWidth
                  name='sellType'
                  sx={{
                    caretColor: theme.palette.secondary.main,
                    "& .MuiInputBase-root": {
                      borderRadius: "8px",
                      backgroundColor: alpha(theme.palette.grey[200], 0.5)
                    }
                  }}
                  {...register("sellType")}
                  select
                >
                  <MenuItem value={1501}>حضوری</MenuItem>
                  <MenuItem value={1502}>اینترنتی</MenuItem>
                  <MenuItem value={1503}>هردو</MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  size='small'
                  label='سابقه فعالیت کسب و کار'
                  fullWidth
                  name='businessHistory'
                  inputProps={{ maxLength: 400 }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position='start'>
                        <Timer1 size={20} color={theme.palette.primary.dark} />
                      </InputAdornment>
                    )
                  }}
                  sx={{
                    caretColor: theme.palette.secondary.main,
                    "& .MuiInputBase-root": {
                      borderRadius: "8px",
                      backgroundColor: alpha(theme.palette.grey[200], 0.5)
                    }
                  }}
                  {...register("businessHistory")}
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid width={"95%"} m='auto' gap={3}>
            <AppStickSection title={"اطلاعات مدیرعامل"} />
            <Grid container spacing={2} item xs={12} display={"flex"}>
              <Grid item xs={12} md={3}>
                <TextField
                  size='small'
                  label='نام و نام خانوادگی مدیرعامل'
                  fullWidth
                  name='ceoFullName'
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position='start'>
                        <UserSquare size={20} color={theme.palette.primary.dark} />
                      </InputAdornment>
                    )
                  }}
                  sx={{
                    caretColor: theme.palette.secondary.main,
                    "& .MuiInputBase-root": {
                      borderRadius: "8px",
                      backgroundColor: alpha(theme.palette.grey[200], 0.5)
                    }
                  }}
                  {...register("ceoFullName", {
                    required: {
                      value: true,
                      message: "نام و نام خانوادگی مدیرعامل شرکت الزامی است"
                    }
                  })}
                />
                <ValidationHelperText
                  error={!!errors?.ceoFullName}
                  helperText={errors?.ceoFullName?.message as string}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  size='small'
                  label='کد ملی مدیرعامل'
                  fullWidth
                  name='ownerNationalCode'
                  onKeyDown={onlyDigitsWithMaxLen(10)}
                  type='number'
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position='start'>
                        <Personalcard size={20} color={theme.palette.primary.dark} />
                      </InputAdornment>
                    )
                  }}
                  sx={{
                    caretColor: theme.palette.secondary.main,
                    "& .MuiInputBase-root": {
                      borderRadius: "8px",
                      backgroundColor: alpha(theme.palette.grey[200], 0.5)
                    }
                  }}
                  {...register("ownerNationalCode", {
                    required: {
                      value: true,
                      message: "کد ملی مدیرعامل شرکت الزامی است"
                    }
                  })}
                />
                <ValidationHelperText
                  error={!!errors?.ownerNationalCode}
                  helperText={errors?.ownerNationalCode?.message as string}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  size='small'
                  label='شماره موبایل مدیرعامل'
                  fullWidth
                  name='ceoPhoneNumber'
                  type='number'
                  onKeyDown={onlyDigitsWithMaxLen(11)}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position='start'>
                        <Mobile size={20} color={theme.palette.primary.dark} />
                      </InputAdornment>
                    )
                  }}
                  sx={{
                    caretColor: theme.palette.secondary.main,
                    "& .MuiInputBase-root": {
                      borderRadius: "8px",
                      backgroundColor: alpha(theme.palette.grey[200], 0.5)
                    }
                  }}
                  {...register("ceoPhoneNumber", {
                    required: {
                      value: true,
                      message: "شماره موبایل الزامی است"
                    }
                  })}
                />
                <ValidationHelperText
                  error={!!errors?.ceoPhoneNumber}
                  helperText={errors?.ceoPhoneNumber?.message as string}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  type='number'
                  size='small'
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position='start'>
                        <Call size={20} color={theme.palette.primary.dark} />
                      </InputAdornment>
                    )
                  }}
                  sx={{
                    caretColor: theme.palette.secondary.main,
                    "& .MuiInputBase-root": {
                      borderRadius: "8px",
                      backgroundColor: alpha(theme.palette.grey[200], 0.5)
                    }
                  }}
                  label='تلفن ثابت'
                  fullWidth
                  name='telephoneNumber'
                  onKeyDown={onlyDigitsWithMaxLen(11)}
                  {...register("telephoneNumber")}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  size='small'
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position='start'>
                        <Sms size={20} color={theme.palette.primary.dark} />
                      </InputAdornment>
                    )
                  }}
                  sx={{
                    caretColor: theme.palette.secondary.main,
                    "& .MuiInputBase-root": {
                      borderRadius: "8px",
                      backgroundColor: alpha(theme.palette.grey[200], 0.5)
                    }
                  }}
                  label='پست الکترونیکی'
                  fullWidth
                  inputProps={{ maxLength: 50 }}
                  name='email'
                  {...register("email", { validate: handleEmailValidation })}
                />
                <ValidationHelperText error={!!errors?.email} helperText={"آدرس ایمیل صحیح نیست"} />{" "}
              </Grid>
            </Grid>
          </Grid>

          <Grid width={"95%"} m='auto' gap={3}>
            <AppStickSection title={"اطلاعات نماینده"} />
            <Grid container spacing={2} item xs={12} display={"flex"}>
              <Grid item xs={12} md={3}>
                <TextField
                  size='small'
                  inputProps={{ maxLength: 50 }}
                  label='نام و نام خانوادگی نماینده'
                  fullWidth
                  name='agentFullName'
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position='start'>
                        <UserSquare size={20} color={theme.palette.primary.dark} />
                      </InputAdornment>
                    )
                  }}
                  sx={{
                    caretColor: theme.palette.secondary.main,
                    "& .MuiInputBase-root": {
                      borderRadius: "8px",
                      backgroundColor: alpha(theme.palette.grey[200], 0.5)
                    }
                  }}
                  {...register("agentFullName")}
                />
                <ValidationHelperText
                  error={!!errors?.agentFullName}
                  helperText={errors?.agentFullName?.message as string}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  size='small'
                  label='شماره موبایل نماینده'
                  fullWidth
                  name='agentPhoneNumber'
                  type='number'
                  onKeyDown={onlyDigitsWithMaxLen(11)}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position='start'>
                        <Mobile size={20} color={theme.palette.primary.dark} />
                      </InputAdornment>
                    )
                  }}
                  sx={{
                    caretColor: theme.palette.secondary.main,
                    "& .MuiInputBase-root": {
                      borderRadius: "8px",
                      backgroundColor: alpha(theme.palette.grey[200], 0.5)
                    }
                  }}
                  {...register("agentPhoneNumber", {
                    minLength: {
                      value: 11,
                      message: "شماره تماس باید 11 رقم باشد"
                    },

                    validate: mobileValidation
                  })}
                />
                <ValidationHelperText
                  error={!!errors?.agentPhoneNumber}
                  helperText={errors?.agentPhoneNumber?.message as string}
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid width={"95%"} m='auto' gap={3}>
            <AppStickSection title={"اطلاعات حساب بانکی"} />
            <Grid container spacing={2} item xs={12} display={"flex"}>
              <Grid item xs={12} md={3}>
                <TextField
                  size='small'
                  label='شماره حساب بانک ملت '
                  fullWidth
                  name='mellatAcountNumber'
                  type='number'
                  onKeyDown={onlyDigitsWithMaxLen(10)}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position='start'>
                        <Card size={20} color={theme.palette.primary.dark} />
                      </InputAdornment>
                    )
                  }}
                  sx={{
                    caretColor: theme.palette.secondary.main,
                    "& .MuiInputBase-root": {
                      borderRadius: "8px",
                      backgroundColor: alpha(theme.palette.grey[200], 0.5)
                    }
                  }}
                  {...register("mellatAcountNumber")}
                />
              </Grid>
              {/* <Grid item xs={12} md={4}>
                <TextField
                  label='مگابانک'
                  fullWidth
                  name='megaBank'
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position='start'>
                        <Card size={20} color={theme.palette.primary.dark} />
                      </InputAdornment>
                    )
                  }}
                  sx={{
                    caretColor: theme.palette.secondary.main,
                    "& .MuiInputBase-root": {
                      borderRadius: "8px",
                      backgroundColor: alpha(theme.palette.grey[200], 0.5)
                    }
                  }}
                  {...register("megaBank")}
                />
              </Grid> */}
              <Grid item xs={12} md={3}>
                <TextField
                  size='small'
                  label='پایانه پرداخت اول (به پرداخت ملت) '
                  fullWidth
                  name='mellatTerminalNumber1'
                  onKeyDown={onlyDigitsWithMaxLen(15)}
                  type='number'
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position='start'>
                        <CardPos size={20} color={theme.palette.primary.dark} />
                      </InputAdornment>
                    )
                  }}
                  sx={{
                    caretColor: theme.palette.secondary.main,
                    "& .MuiInputBase-root": {
                      borderRadius: "8px",
                      backgroundColor: alpha(theme.palette.grey[200], 0.5)
                    }
                  }}
                  {...register("mellatTerminalNumber1")}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  size='small'
                  label='پایانه پرداخت دوم (به پرداخت ملت) '
                  fullWidth
                  name='mellatTerminalNumber2'
                  type='number'
                  onKeyDown={onlyDigitsWithMaxLen(15)}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position='start'>
                        <CardPos size={20} color={theme.palette.primary.dark} />
                      </InputAdornment>
                    )
                  }}
                  sx={{
                    caretColor: theme.palette.secondary.main,
                    "& .MuiInputBase-root": {
                      borderRadius: "8px",
                      backgroundColor: alpha(theme.palette.grey[200], 0.5)
                    }
                  }}
                  {...register("mellatTerminalNumber2")}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  size='small'
                  label='پایانه پرداخت سوم (به پرداخت ملت) '
                  fullWidth
                  name='mellatTerminalNumber3'
                  type='number'
                  onKeyDown={onlyDigitsWithMaxLen(15)}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position='start'>
                        <CardPos size={20} color={theme.palette.primary.dark} />
                      </InputAdornment>
                    )
                  }}
                  sx={{
                    caretColor: theme.palette.secondary.main,
                    "& .MuiInputBase-root": {
                      borderRadius: "8px",
                      backgroundColor: alpha(theme.palette.grey[200], 0.5)
                    }
                  }}
                  {...register("mellatTerminalNumber3")}
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid width={"95%"} m='auto' gap={3}>
            <AppStickSection title={"اطلاعات محل کسب و کار"} />
            <Grid container spacing={2} item xs={12} display={"flex"}>
              <Grid item xs={12} md={3}>
                <TextField
                  size='small'
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position='start'>
                        <Box size={20} color={theme.palette.primary.dark} />
                      </InputAdornment>
                    )
                  }}
                  sx={{
                    caretColor: theme.palette.secondary.main,
                    "& .MuiInputBase-root": {
                      borderRadius: "8px",
                      backgroundColor: alpha(theme.palette.grey[200], 0.5)
                    }
                  }}
                  label='کدپستی'
                  fullWidth
                  name='postalCode'
                  type='number'
                  onKeyDown={onlyDigitsWithMaxLen(10)}
                  {...register("postalCode")}
                />
              </Grid>
              <Grid item xs={12} md={8}>
                <TextField
                  size='small'
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position='start'>
                        <Location size={20} color={theme.palette.primary.dark} />
                      </InputAdornment>
                    )
                  }}
                  sx={{
                    caretColor: theme.palette.secondary.main,
                    "& .MuiInputBase-root": {
                      borderRadius: "8px",
                      backgroundColor: alpha(theme.palette.grey[200], 0.5)
                    }
                  }}
                  multiline
                  minRows={2}
                  label='نشانی'
                  fullWidth
                  name='address'
                  inputProps={{ maxLength: 400 }}
                  {...register("address")}
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid width={"95%"} m='auto' gap={3}>
            <AppStickSection title={"سایت ها"} />
            <Grid container spacing={2} item xs={12} display={"flex"}>
              <Grid item xs={12} md={3}>
                <TextField
                  size='small'
                  label='آدرس سایت اول'
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position='start'>
                        <GlobalSearch size={20} color={theme.palette.primary.dark} />
                      </InputAdornment>
                    )
                  }}
                  inputProps={{ maxLength: 50 }}
                  sx={{
                    caretColor: theme.palette.secondary.main,
                    "& .MuiInputBase-root": {
                      borderRadius: "8px",
                      backgroundColor: alpha(theme.palette.grey[200], 0.5)
                    }
                  }}
                  fullWidth
                  name='website1'
                  {...register("website1")}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  size='small'
                  label='آدرس سایت دوم'
                  inputProps={{ maxLength: 50 }}
                  fullWidth
                  name='website2'
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position='start'>
                        <GlobalSearch size={20} color={theme.palette.primary.dark} />
                      </InputAdornment>
                    )
                  }}
                  sx={{
                    caretColor: theme.palette.secondary.main,
                    "& .MuiInputBase-root": {
                      borderRadius: "8px",
                      backgroundColor: alpha(theme.palette.grey[200], 0.5)
                    }
                  }}
                  {...register("website2")}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  size='small'
                  label='آدرس سایت سوم'
                  inputProps={{ maxLength: 50 }}
                  fullWidth
                  name='website3'
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position='start'>
                        <GlobalSearch size={20} color={theme.palette.primary.dark} />
                      </InputAdornment>
                    )
                  }}
                  sx={{
                    caretColor: theme.palette.secondary.main,
                    "& .MuiInputBase-root": {
                      borderRadius: "8px",
                      backgroundColor: alpha(theme.palette.grey[200], 0.5)
                    }
                  }}
                  {...register("website3")}
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid width={"95%"} m='auto' gap={3}>
            <AppStickSection title={"شبکه های اجتماعی"} />
            <Grid container spacing={2} item xs={12} display={"flex"}>
              <Grid item xs={12} md={3}>
                <TextField
                  size='small'
                  label='اینستاگرام'
                  fullWidth
                  name='instagram'
                  inputProps={{ maxLength: 50 }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position='start'>
                        <Instagram size={20} color={theme.palette.primary.dark} />
                      </InputAdornment>
                    )
                  }}
                  sx={{
                    caretColor: theme.palette.secondary.main,
                    "& .MuiInputBase-root": {
                      borderRadius: "8px",
                      backgroundColor: alpha(theme.palette.grey[200], 0.5)
                    }
                  }}
                  {...register("instagram")}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  size='small'
                  label='تلگرام'
                  fullWidth
                  name='telegram'
                  inputProps={{ maxLength: 50 }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position='start'>
                        <Telegram sx={{ color: theme.palette.primary.dark }} />
                      </InputAdornment>
                    )
                  }}
                  sx={{
                    caretColor: theme.palette.secondary.main,
                    "& .MuiInputBase-root": {
                      borderRadius: "8px",
                      backgroundColor: alpha(theme.palette.grey[200], 0.5)
                    }
                  }}
                  {...register("telegram")}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  size='small'
                  label='لینکدین'
                  fullWidth
                  name='linkedIn'
                  inputProps={{ maxLength: 50 }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position='start'>
                        <LinkedIn sx={{ color: theme.palette.primary.dark }} />
                      </InputAdornment>
                    )
                  }}
                  sx={{
                    caretColor: theme.palette.secondary.main,
                    "& .MuiInputBase-root": {
                      borderRadius: "8px",
                      backgroundColor: alpha(theme.palette.grey[200], 0.5)
                    }
                  }}
                  {...register("linkedIn")}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  label='توییتر'
                  size='small'
                  fullWidth
                  name='twitter'
                  inputProps={{ maxLength: 50 }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position='start'>
                        <Twitter sx={{ color: theme.palette.primary.dark }} />
                      </InputAdornment>
                    )
                  }}
                  sx={{
                    caretColor: theme.palette.secondary.main,
                    "& .MuiInputBase-root": {
                      borderRadius: "8px",
                      backgroundColor: alpha(theme.palette.grey[200], 0.5)
                    }
                  }}
                  {...register("twitter")}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  label='فیسبوک'
                  size='small'
                  fullWidth
                  name='facebook'
                  inputProps={{ maxLength: 50 }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position='start'>
                        <Facebook sx={{ color: theme.palette.primary.dark }} />
                      </InputAdornment>
                    )
                  }}
                  sx={{
                    caretColor: theme.palette.secondary.main,
                    "& .MuiInputBase-root": {
                      borderRadius: "8px",
                      backgroundColor: alpha(theme.palette.grey[200], 0.5)
                    }
                  }}
                  {...register("facebook")}
                />
              </Grid>
              {/* <Grid item xs={12} md={4}>
                <TextField
                  label='مگا بانک'
                  fullWidth
                  name='megaBank'
                  inputProps={{ maxLength: 50 }}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position='start'>
                        <Message size={20} color={theme.palette.primary.dark} />
                      </InputAdornment>
                    )
                  }}
                  sx={{
                    caretColor: theme.palette.secondary.main,
                    "& .MuiInputBase-root": {
                      borderRadius: "8px",
                      backgroundColor: alpha(theme.palette.grey[200], 0.5)
                    }
                  }}
                  {...register("megaBank")}
                />
              </Grid> */}
            </Grid>
          </Grid>

          <Grid width={"95%"} m='auto' gap={3}>
            <AppStickSection title={"توضیحات"} />
            <Grid item xs={12} md={12}>
              <TextField
                label='توضیحات'
                size='small'
                fullWidth
                multiline
                minRows={3}
                inputProps={{ maxLength: 400 }}
                name='description'
                InputProps={{
                  endAdornment: (
                    <InputAdornment position='start'>
                      <Note size={20} color={theme.palette.primary.dark} />
                    </InputAdornment>
                  )
                }}
                sx={{
                  caretColor: theme.palette.secondary.main,
                  "& .MuiInputBase-root": {
                    borderRadius: "8px",
                    backgroundColor: alpha(theme.palette.grey[200], 0.5)
                  }
                }}
                {...register("description")}
              />
            </Grid>
          </Grid>

          <Grid width={"95%"} m='auto' gap={3}>
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <Grid md={4} xs={12}>
                <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
                  <Button
                    variant='contained'
                    size='large'
                    sx={{ borderRadius: "8px", width: "49%" }}
                    disableElevation
                    color='info'
                    fullWidth
                    onClick={DownloadContractFile}
                    endIcon={<DocumentDownload />}
                  >
                    دانلود پیش نویس قرارداد
                  </Button>
                  <Button
                    disabled={state === "loading"}
                    type='submit'
                    variant='contained'
                    size='large'
                    sx={{ borderRadius: "8px", width: "49%" }}
                    disableElevation
                    endIcon={<TickSquare />}
                    fullWidth
                  >
                    {state === "loading" ? <CircularProgress size={18} /> : "ثبت درخواست"}
                  </Button>
                </div>
              </Grid>
              {/* </div> */}
            </div>
          </Grid>
        </Grid>
      </form>
    </Grid>
  )
}

export default Legal
